import ApiService from "@/core/services/api.service";
import Vue from "vue";

const state = {
  items: [],
  meta: {},
  isBusy: false,
};

const actions = {
  fetchCompanyHolidays(context) {
    state.isBusy = true;
    ApiService.setHeader();
    Vue.axios
      .get("holiday/record", {
        params: {
          "page[number]": state.meta.current_page ?? 1,
        },
      })
      .then((response) => {
        console.log("Received from holiday/record", response);
        context.commit("setCompanyHolidayList", response.data.data);
        context.commit(
          "setCompanyHolidayListPagination",
          response.data.meta.pagination
        );
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => (state.isBusy = false));
  },
};

const mutations = {
  /**
   *
   * @param state
   * @param data
   */
  setCompanyHolidayList(state, data) {
    state.items = data;
  },

  /**
   *
   * @param state
   * @param pagination
   */
  setCompanyHolidayListPagination(state, pagination) {
    console.log("Pagination", pagination);
    state.meta = pagination;
  },

  /**
   *
   * @param state
   * @param currentPage
   */
  setCompanyHolidayListPaginationPage(state, currentPage) {
    state.meta.current_page = currentPage;
  },
};

const getters = {
  getCompanyHolidayList: (state) => state.items,
  getCompanyHolidayListPagination: (state) => state.meta,
  getCompanyHolidayListBusy: (state) => state.isBusy,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
